import React from 'react';
import './CalculatorPage.css';

import { PageTitle } from '../../../components';
import { Calculator } from '../../../sections';



const CalculatorPage = () => {

  return (

    <div className='calculator-page'>

      {/* Page Title */}
      <PageTitle title={'Cost Calculator'} page={'Cost Calculator'} />

      {/* Cost Calculator Section */}
      <Calculator />

    </div>

  );

}

export default CalculatorPage;